<button
  class="relative flex size-full items-center justify-center drop-shadow-lg duration-75 hover:-translate-y-[1px] hover:scale-105 active:translate-y-[5px] active:scale-100"
  (click)="clicked.emit()"
  [style]="{
    filter: disabled() ? 'grayscale(1)' : undefined,
    pointerEvents: disabled() ? 'none' : undefined,
    transition: 'filter 0.2s ease-in-out, transform 0.1s ease-in-out',
  }"
>
  <img class="pointer-events-none absolute inset-0 size-full object-contain select-none" [src]="backgroundPath()" />
  <img class="pointer-events-none absolute size-2/3 object-contain select-none" [src]="iconPath()" />
</button>
